import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children", "style", "className", "offsets", "isDisabled"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useMemo, useState, useLayoutEffect, useImperativeHandle, cloneElement, forwardRef, memo, Children } from 'react';
import Box from '@rexlabs/box';
import { useStyles, useToken, StyleSheet } from '@rexlabs/styling';
import { useResizeObserver } from '@rexlabs/react-hooks';
import { Observer } from './observer';
import { combineBackgroundStyles } from './utils';
import { isEqual } from 'lodash';
var defaultStyles = StyleSheet({
  container: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'auto'
  },
  stickyContainerX: {
    position: 'sticky',
    top: 0
  },
  stickyContainerY: {
    position: 'sticky',
    left: 0
  },
  absoluteContainerX: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pointerEvents: 'none'
  },
  absoluteContainerY: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    pointerEvents: 'none'
  },
  shadow: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    pointerEvents: 'none',
    backgroundRepeat: 'no-repeat'
  }
});
export var ScrollShadowInner = /*#__PURE__*/forwardRef(function ScrollShadow(_ref, ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      offsets = _ref.offsets,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles);
  var token = useToken();

  var _useState = useState({
    height: 0,
    width: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      containerDimensions = _useState2[0],
      setContainerDimensions = _useState2[1];

  var _useState3 = useState({
    height: 0,
    width: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      contentDimensions = _useState4[0],
      setContentDimensions = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      intersectingTop = _useState6[0],
      setIntersectingTop = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      intersectingRight = _useState8[0],
      setIntersectingRight = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      intersectingBottom = _useState10[0],
      setIntersectingBottom = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      intersectingLeft = _useState12[0],
      setIntersectingLeft = _useState12[1];

  var containerRef = useResizeObserver(function (_ref2) {
    var _target$clientHeight, _target$clientWidth;

    var target = _ref2.target;
    return setContainerDimensions({
      height: (_target$clientHeight = target === null || target === void 0 ? void 0 : target.clientHeight) !== null && _target$clientHeight !== void 0 ? _target$clientHeight : 0,
      width: (_target$clientWidth = target === null || target === void 0 ? void 0 : target.clientWidth) !== null && _target$clientWidth !== void 0 ? _target$clientWidth : 0
    });
  }, []);
  var contentRef = useResizeObserver(function (_ref3) {
    var _target$clientHeight2, _target$clientWidth2;

    var target = _ref3.target;
    return setContentDimensions({
      height: (_target$clientHeight2 = target === null || target === void 0 ? void 0 : target.clientHeight) !== null && _target$clientHeight2 !== void 0 ? _target$clientHeight2 : 0,
      width: (_target$clientWidth2 = target === null || target === void 0 ? void 0 : target.clientWidth) !== null && _target$clientWidth2 !== void 0 ? _target$clientWidth2 : 0
    });
  }, []);
  var shadowStyles = useMemo(function () {
    return {
      top: {
        size: token('scrollShadow.top.size', '100% 4px'),
        position: function position() {
          var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return "50% calc(0% + ".concat(offset, "px)");
        },
        image: token('scrollShadow.top.gradient', 'linear-gradient(to bottom, rgba(219, 220, 222, 0.55) 0%, rgba(255, 255, 255, 0) 130%)'),
        initialPosition: '50% calc(0% - 4px)'
      },
      right: {
        size: token('scrollShadow.right.size', '4px 100%'),
        position: function position() {
          var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return "calc(100% - ".concat(offset, "px) 50%");
        },
        image: token('scrollShadow.right.gradient', 'linear-gradient(to left, rgba(219, 220, 222, 0.55) 0%, rgba(255, 255, 255, 0) 130%)'),
        initialPosition: 'calc(100% + 4px) 50%'
      },
      bottom: {
        size: token('scrollShadow.bottom.size', '100% 4px'),
        position: function position() {
          var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return "50% calc(100% - ".concat(offset, "px)");
        },
        image: token('scrollShadow.bottom.gradient', 'linear-gradient(to top, rgba(219, 220, 222, 0.55) 0%, rgba(255, 255, 255, 0) 130%)'),
        initialPosition: '50% calc(100% + 4px)'
      },
      left: {
        size: token('scrollShadow.left.size', '4px 100%'),
        position: function position() {
          var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return "calc(0% + ".concat(offset, "px) 50%");
        },
        image: token('scrollShadow.left.gradient', 'linear-gradient(to right, rgba(219, 220, 222, 0.55) 0%, rgba(255, 255, 255, 0) 130%)'),
        initialPosition: '-4px 100%'
      }
    };
  }, [token]);
  var shadowZIndex = token('scrollShadow.zIndex', _parseInt(token('zIndex.base', 0)) + 1); // If we scroll down fast enough after mounting then the
  // intersection observer doesn't fire the callback and
  // set the correct intersecting state so this ensures
  // that the correct state is set on mount

  useLayoutEffect(function () {
    if (contentRef.current) {
      var _contentRef$current = contentRef.current,
          scrollTop = _contentRef$current.scrollTop,
          scrollLeft = _contentRef$current.scrollLeft,
          scrollHeight = _contentRef$current.scrollHeight,
          scrollWidth = _contentRef$current.scrollWidth,
          clientHeight = _contentRef$current.clientHeight,
          clientWidth = _contentRef$current.clientWidth;

      if (scrollTop > 0) {
        setIntersectingTop(false);
      }

      if (scrollLeft + clientWidth < scrollWidth) {
        setIntersectingRight(false);
      }

      if (scrollTop + clientHeight < scrollHeight) {
        setIntersectingBottom(false);
      }

      if (scrollLeft > 0) {
        setIntersectingLeft(false);
      }
    }
  }, [contentRef]);
  useImperativeHandle(ref, function () {
    return containerRef.current;
  });
  var child = Children.only(children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, _extends({}, s.with('container')({
    style: style,
    className: className
  }), {
    ref: containerRef
  }, props), /*#__PURE__*/React.createElement("span", s('stickyContainerX'), /*#__PURE__*/React.createElement("span", s.with('absoluteContainerX')({
    height: containerDimensions.height,
    width: contentDimensions.width
  }), /*#__PURE__*/React.createElement(Observer, {
    root: containerRef.current,
    setIntersecting: setIntersectingLeft
  }), /*#__PURE__*/React.createElement(Observer, {
    root: containerRef.current,
    setIntersecting: setIntersectingRight
  }))), /*#__PURE__*/React.createElement("span", s('stickyContainerY'), /*#__PURE__*/React.createElement("span", s.with('absoluteContainerY')({
    height: contentDimensions.height,
    width: containerDimensions.width
  }), /*#__PURE__*/React.createElement(Observer, {
    root: containerRef.current,
    setIntersecting: setIntersectingTop
  }), /*#__PURE__*/React.createElement(Observer, {
    root: containerRef.current,
    setIntersecting: setIntersectingBottom
  }))), /*#__PURE__*/cloneElement(child, {
    ref: contentRef
  })), /*#__PURE__*/React.createElement("span", s.with('shadow')(_objectSpread({
    zIndex: shadowZIndex
  }, combineBackgroundStyles({
    offsets: offsets,
    shadowStyles: shadowStyles,
    activeShadows: {
      top: !intersectingTop && !isDisabled,
      right: !intersectingRight && !isDisabled,
      bottom: !intersectingBottom && !isDisabled,
      left: !intersectingLeft && !isDisabled
    }
  })))));
});
export var ScrollShadow = /*#__PURE__*/memo(ScrollShadowInner, isEqual);